import { useEffect } from 'react';
// TODO: use ../hooks/useLayer hook instead of ref
export function useLayerEffect(ref, { visible, opacity, zIndex }) {
    useEffect(() => {
        if (!ref.current)
            return;
        ref.current.setVisible(visible ?? false);
    }, [ref, visible]);
    useEffect(() => {
        if (!ref.current)
            return;
        ref.current.setOpacity(opacity ?? 1);
    }, [ref, opacity]);
    useEffect(() => {
        if (!ref.current)
            return;
        ref.current.setZIndex(zIndex ?? 0);
    }, [ref, zIndex]);
}
//# sourceMappingURL=useLayerEffect.js.map